import cx from "classnames";
import React from "react";
import styles from "./ListMinimal.scss";

export class ListMinimal extends React.PureComponent {
  render() {
    const { children, interactive, expanded, className, ...props } = this.props;
    return (
      <ul
        className={cx(styles.ListMinimal, interactive && styles.interactive, expanded && styles.expanded, className)}
        {...props}
      >
        {children}
      </ul>
    );
  }
}
